module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAMAAACnUt2HAAAAdVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////li2ZAAAAAJnRSTlMAEvV2+Z+bjA3t1piQZfHotquGgn1dSyofFQPh387EcFhSQjkyJFZ0iGIAAACJSURBVBjTZc5XDsMgEEXRiU0SDLiX2On17X+JGQESBp8f4EozgrxhzzqKPY4sT+I9Y7ckjjkrkzgcWJ/EK1gR3lNrjKlt1Fo3bsevwtqJrLMK6SLJkzW8YglrZxFmg69rH4q8wSbyVOPOFzC6W6sIIKfv/F+4CMwUWThWKHeWlO58IqMMG4LHt/7CUhQdq1NiMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/download.png
// module id = gRyQ
// module chunks = 0 1